const renaissanceConfig = Object.freeze({
    LABEL: 'RenSecureHealth',
    SHORT_LABEL: 'RenSecureHealth',
    NAME: 'renaissance',
    PALETTE: {
        PRIMARY: '#0067A1',
        SECONDARY: '#223a67'
    },
    CONTACT_SUPPORT: {
        EMAIL: 'support@rensecurehealth.com',
        NUMBER: '(888) 612-1172',
        SALES: 'sales@joinansel.com',
        WEB_SITE: 'https://renaissancebenefits.com'
    },
    S3: {
        BASE_URL: 'https://joinansel-platform-assets.s3.us-east-1.amazonaws.com',
        SP_NAME: 'renaissance',
        APPLICATION: 'enrollment',
    },
    LEGAL:{
        SERVICE_NAME: 'Renaissance Life & Health Insurance Company of America',
        INSURANCE_NAME: 'Renaissance Holding Company.',
        TERMS: 'https://renaissancebenefits.com/terms-of-service/',
        PRIVACY: 'https://renaissancebenefits.com/privacy/'
    },
});

export default renaissanceConfig;
